export default function (details?: BillingDetailsI | null): BillingDetailsI {
  if (!details) return {
    sameAsDelivery: false,
    name: '',
    country: '',
    city: '',
    zipCode: '',
    address: '',
    phone: '',
    vat: '',
  };

  return {
    sameAsDelivery: details.sameAsDelivery || false,
    name: details.name || '',
    country: details.country || '',
    city: details.city || '',
    zipCode: details.zipCode || '',
    address: details.address || '',
    phone: details.phone || '',
    vat: details.vat || '',
  };
}
